import React from "react";
import { useGetProtectedSitesQuery } from "../../../features/sites/sitesApiSlice";
import SiteCardItemList from "./SiteCardItemList";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import Iconify from "../../../components/iconify/Iconify";
import { Typography } from "@mui/material";

function SitesView() {
  const { data: sites, isLoading } = useGetProtectedSitesQuery();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!sites) {
    return (
      <div style={{ textAlign: "center" }}>
        <div>
          <Iconify icon={"fa-solid:torii-gate"} width={250} height={250} />
        </div>
        <Typography variant="h3">Noch keine Standorte!</Typography>
      </div>
    );
  }

  return <div>{sites && <SiteCardItemList sites={sites} />}</div>;
}

export default SitesView;
